import { render } from "./radioField.vue?vue&type=template&id=a9981fb0"
import script from "./radioField.vue?vue&type=script&lang=js"
export * from "./radioField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__